import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Sidebar from "../../partials/aside/Sidebar";
import ButtonDisable from "../../partials/other/ButtonDisable";
import TitleBar from "../../partials/content/TitleBar";
import CategorySitePublisherTopic from "../../sections/publisher/CategorySitePublisherTopic";

const typeUserString = {
  REAL: 1,
  LEGAL: 2,
};
export default function AddUserCustomerCoWorker() {
  const [typeUser, setTypeUser] = useState(typeUserString.REAL);
  const [showPassword, setShowPassword] = useState(false);

  const [message, setMessage] = useState();
  const history = useHistory();

  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateTagsCategoriesSitesPublishers = (categoriesSitesPublishers) => {
    return categoriesSitesPublishers.map((categorySitesPublishers, index) => {
      return (
        <>
          <option key={index} value={categorySitesPublishers.cas_id}>
            {categorySitesPublishers.cas_name}
          </option>
        </>
      );
    });
  };

  const popover = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      <span style={{ fontFamily: "IRANSansWeb" }}>
        <span>در این</span>
        <span>
          <Link
            className="px-1 d-inline-block"
            target="_blank"
            to="/publishers/list-category-site-publisher"
          >
            صفحه
          </Link>
        </span>
        <span>میتوانید تمامی دسته های صنفی را مشاهده کنید.</span>
      </span>
    </Tooltip>
  );

  const showSelectCategorySitePublisher = () => {
    return (
      <select className="form-control">
        {CategorySitePublisherTopic.map((category) => {
          return <option>{category.title}</option>;
        })}
      </select>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="اضافه کردن کاربر مشتریان همکار" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body" id="fill-info-user-customer">
              <div className="text-left">
                <Link className="text-white" to="/user/all-customer-coworker">
                  <div className="btn btn-primary">
                    <span>
                      <span className="text-white">بازگشت</span>
                    </span>
                    <span className="pr-2">
                      <i className="fas fa-arrow-left" aria-hidden="true"></i>
                    </span>
                  </div>
                </Link>
              </div>
              <div>
                <form>
                  <div className="d-flex flex-column flex-lg-row">
                    <div className="flex-1 form-group px-lg-2">
                      <label>ایمیل</label>
                      <span class="text-danger">*</span>
                      <input
                        type="text"
                        className="form-control"
                        id="email"
                        placeholder="ایمیل"
                        required
                      />
                    </div>

                    <div
                      dir="ltr"
                      className="flex-1 form-group px-lg-2 px-lg-2 d-flex align-items-end flex-column"
                    >
                      <label>
                        <span class="text-danger">*</span>
                        رمز عبور
                      </label>
                      <div dir="rtl" className="input-group">
                        <input
                          type={showPassword ? "text" : "password"}
                          className="form-control"
                          id="password"
                          required
                        />
                        <div className="input-group-append">
                          <button
                            className="btn btn-secondary"
                            type="button"
                            onClick={(e) => {
                              e.preventDefault();
                              setShowPassword((prevState) => !prevState);
                            }}
                          >
                            <i
                              class={
                                showPassword ? "fa fa-eye-slash" : "fa fa-eye"
                              }
                            ></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex flex-column flex-lg-row">
                    <div className="flex-1 form-group px-lg-2">
                      <label>شماره موبایل</label>
                      <span class="text-danger">*</span>
                      <input
                        type="number"
                        className="form-control"
                        id="mobile"
                        placeholder="09121234567"
                        required
                      />
                    </div>
                    <div className="flex-1 form-group px-lg-2 px-lg-2">
                      <label>دسته صنفی</label>
                      <span className="text-danger pl-2">*</span>

                      <OverlayTrigger
                        trigger="click"
                        rootClose
                        placement="top"
                        overlay={popover}
                      >
                        <span className="hover bg-warning rounded-circle py-1 px-3 ">
                          <i className="fa fa-info"></i>
                        </span>
                      </OverlayTrigger>
                      {showSelectCategorySitePublisher()}
                    </div>
                  </div>

                  <div className="card-body p-0">
                    <div className="form-group px-lg-2 ">
                      <label>نوع کاربر</label>
                      <span class="text-danger">*</span>
                    </div>
                    <div className="d-flex flex-column flex-md-row">
                      <div className="form-group px-lg-2 d-flex">
                        <div className="form-check pl-2 ">
                          <input
                            className="form-check-input hover"
                            type="radio"
                            name="type-user"
                            id="real-person"
                            checked={typeUser === typeUserString.REAL}
                            onChange={(e) => {
                              setTypeUser(typeUserString.REAL);
                            }}
                          />
                          <label
                            className="form-check-label hover"
                            for="real-person"
                          >
                            شخص حقیقی
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input hover"
                            type="radio"
                            name="type-user"
                            id="legal-person"
                            checked={typeUser === typeUserString.LEGAL}
                            onChange={(e) => {
                              setTypeUser(typeUserString.LEGAL);
                            }}
                          />
                          <label
                            className="form-check-label hover"
                            for="legal-person"
                          >
                            شخص حقوقی
                          </label>
                        </div>
                      </div>
                    </div>
                    <div>
                      <hr />
                    </div>
                    <div className="d-flex flex-column flex-md-row">
                      {typeUser == typeUserString.REAL ? (
                        <>
                          {" "}
                          <div className="form-group px-lg-2 ">
                            <label>
                              نام
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="first-name"
                              placeholder="نام"
                              required
                            />
                          </div>
                          <div className="form-group px-lg-2">
                            <label>نام خانوادگی</label>
                            <span className="text-danger">*</span>
                            <input
                              type="text"
                              className="form-control"
                              id="last-name"
                              placeholder="نام خانوادگی"
                              required
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="form-group px-lg-2">
                            <label>نام شخص حقوقی</label>
                            <span className="text-danger">*</span>
                            <input
                              type="text"
                              className="form-control"
                              id="first-name"
                              placeholder="نام شخص حقوقی"
                              required
                            />
                          </div>
                        </>
                      )}
                    </div>
                    <div>
                      <hr />
                    </div>
                    {typeUser == typeUserString.REAL ? (
                      <>
                        <div className="d-flex flex-column flex-md-row">
                          <div className="form-group px-lg-2">
                            <label>شماره تلفن ثابت</label>
                            <input
                              type="number"
                              className="form-control"
                              id="phone"
                              name="phone"
                              placeholder="شماره تلفن ثابت"
                            />
                          </div>

                          <div className="form-group px-lg-2">
                            <label>کد ملی</label>
                            <input
                              type="number"
                              className="form-control"
                              id="national-code"
                              name="national-code"
                              placeholder="کد ملی"
                            />
                          </div>

                          <div className="form-group px-lg-2">
                            <label>شماره شناسنامه</label>
                            <input
                              type="number"
                              className="form-control"
                              id="identity-number"
                              name="identity-number"
                              placeholder="شماره شناسنامه"
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                    {typeUser == typeUserString.LEGAL ? (
                      <>
                        <div className="d-flex flex-column flex-md-row">
                          <div className="form-group px-lg-2">
                            <label>شماره تلفن ثابت</label>
                            <input
                              type="number"
                              className="form-control"
                              id="phone"
                              name="phone"
                              placeholder="شماره تلفن ثابت"
                            />
                          </div>
                          <div className="form-group px-lg-2">
                            <label>شناسه ملی</label>
                            <input
                              type="number"
                              className="form-control"
                              id="identity-national"
                              name="identity-national"
                              placeholder="شناسه ملی"
                            />
                          </div>

                          <div className="form-group px-lg-2">
                            <label>شماره اقتصادی</label>
                            <input
                              type="number"
                              className="form-control"
                              id="economic-number"
                              name="economic-number"
                              placeholder="شماره اقتصادی"
                            />
                          </div>

                          <div className="form-group px-lg-2">
                            <label>شماره ثبت</label>
                            <input
                              type="number"
                              className="form-control"
                              id="register-number"
                              name="register-number"
                              placeholder="شماره ثبت"
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                    <div className="d-flex flex-column flex-md-row">
                      <div className="form-group px-lg-2">
                        <label>استان</label>
                        <input
                          type="text"
                          id="state"
                          className="form-control"
                          placeholder="استان"
                        />
                      </div>
                      <div className="form-group px-lg-2">
                        <label>شهر</label>
                        <input
                          type="text"
                          id="city"
                          className="form-control"
                          placeholder="شهر"
                        />
                      </div>
                      <div className="form-group px-lg-2">
                        <label>شهرستان </label>
                        <input
                          type="text"
                          id="town"
                          className="form-control"
                          placeholder="شهرستان "
                        />
                      </div>

                      <div className="form-group px-lg-2">
                        <label>کد پستی 10 رقمی </label>
                        <input
                          type="number"
                          id="postal-code"
                          className="form-control"
                          placeholder="کد پستی "
                        />
                      </div>
                    </div>
                    <div className="d-flex flex-column form-group  px-lg-2">
                      <label>آدرس دقیق</label>
                      <input
                        type="text"
                        id="address"
                        className="form-control"
                        placeholder="آدرس"
                      />
                    </div>
                    <div className="d-flex flex-column form-group  px-lg-2">
                      <label>توضیحات</label>
                      <textarea
                        type="text"
                        id="description"
                        className="form-control"
                        placeholder="توضیحات"
                        rows="8"
                      ></textarea>
                    </div>
                    <div className="d-flex flex-column flex-md-row">
                      <div className="text-center w-100">
                        <ButtonDisable
                          buttonTagHtml={
                            <span className="btn btn-success opacity-50">
                              {" "}
                              ارسال اطلاعات
                            </span>
                          }
                        ></ButtonDisable>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
